import api from '../token';

export const AddOrcamento = async (payload) => {
  try {
    const response = await api.post('/requestOrcamento',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

